import { useEffect, useState } from "react";

import { dbFirestore } from "../../firestore";

import type { IssuedTicketSnapshot } from "../../firestore/types";

/**
 * 指定eventIdのissuedTickets subcollectionをリアルタイム同期する
 * enablePersistence()が有効な場合、オフライン時はIndexedDBキャッシュから返す
 */
export const useIssuedTickets = (eventId: string | undefined) => {
  const [issuedTickets, setIssuedTickets] = useState<
    Record<string, IssuedTicketSnapshot>
  >({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId) {
      setIssuedTickets({});
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    const unsubscribe = dbFirestore.issuedTickets(eventId).onSnapshot(
      (snapshot) => {
        const tickets: Record<string, IssuedTicketSnapshot> = {};
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data !== null) {
            tickets[doc.id] = data;
          }
        });
        setIssuedTickets(tickets);
        setIsLoading(false);
      },
      (err) => {
        console.error("Failed to listen issuedTickets:", err);
        setError(err);
        setIsLoading(false);
      }
    );

    return unsubscribe;
  }, [eventId]);

  return { issuedTickets, isLoading, error };
};
